module.exports = __webpack_public_path__ + "img/factsheets.c687cafe.svg";